<template>
  <div class="des">
    <!-- <div class="bgc"></div> -->
    <div class="wordDes">
      <leftTabVue :title="tabName" className="top0"></leftTabVue>
      <p class="text">
        {{ des }}
      </p>
      <!-- <div class="whitebox" @click="$router.push('/applications')">
        Learn More
      </div> -->
      <div class="whitebox">
        <cmrbutton path="/company" text="Learn more"></cmrbutton>
      </div>
    </div>
    <div class="imgDes">
      <img src="@/assets/images/home/des.png" alt="" />
    </div>
  </div>
</template>

<script>
import leftTabVue from "@/components/leftTab/index.vue";
import cmrbutton from "@/components/cmrbutton/index.vue";
import { getItem } from "@/utils/localStorage";
export default {
  components: {
    cmrbutton,
    leftTabVue,
  },
  data() {
    return {
      tabName: "",
      des: "",
    };
  },
  mounted() {
    if (getItem("language") == "zh-cn") {
      this.tabName = "关于我们";
      this.des =
        "杭州斯莫尔自成立起一直致力于为客户提供综合磁性产品设计、制造及产品管理服务。从设计、研发、样品验证到量产供应，斯莫尔提供一站式磁学应用服务，产品包括纳米晶磁芯，纳米晶磁芯组件，喷涂磁环，磁钢等，涉及电动汽车，新能源，消费电子，家电，传感等诸多行业领域。";
    } else {
      this.tabName = "About Us";
      this.des =
        "Hangzhou CMR has been committed to providing customers comprehensive magnetic product design, manufacturing and product management service. From design, R&D, sample verification to mass production supply, we provide one-stop magnetic application services, including nanocrystalline cores and components, sprayed magnetic rings and all types of permanent magnetic materials, which cover the fields of electric vehicles, new energy, consumer electronics, home appliances, sensing and many other industries.";
    }
  },
};
</script>

<style lang="less" scoped>
.des {
  margin-top: 1.3rem;
  display: flex;
  justify-content: space-between;
  position: relative;
  // height: 6.5rem;
  // align-items: center;
  //   margin-top: 3rem;
  .bgc {
    position: absolute;
    z-index: -1;
    width: 95%;
    height: 100%;
  }
  .wordDes {
    width: 5.8rem;
    margin-left: 2.6rem;
    .text {
      // font-size: 0.506rem;
      // line-height: 1.28;
      // text-align: justify;
      // font-weight: 900;
    }
    .whitebox {
      // line-height: 0.5rem;
      // text-align: center;
      // width: 3rem;
      // height: 0.5rem;
      margin-top: 0.6rem;
      // background-color: #fff;
      // box-shadow: 2px 2px 2px 1px rgb(217, 217, 217);
      // transition: all 0.5s;
      // &:hover {
      //   transform: scale(1.2);
      //   cursor: pointer;
      // }
    }
  }
  .imgDes {
    margin-right: 2.6rem;
    img {
      width: 8rem;
      // height: 100%;
    }
  }
}
@media screen and (max-width: 760px) {
  .des {
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    height: auto;
    margin-top: 0.6rem;
    .bgc {
      height: 4.5rem;
    }
    .wordDes {
      width: 100%;
      margin-left: 0;
      padding: 0.3rem 0.3rem 0.6rem;
      box-sizing: border-box;
      margin-bottom: 0rem;
      margin-top: 0;
      .text {
        text-align: left;
        font-weight: 500;
      }
      .whitebox {
        // width: 1.5rem;
        // height: 1rem;
        // line-height: 1rem;
        margin-top: 0.6rem;

        margin-left: auto;
        &:hover {
          // transform: scale(1.1);
        }
      }
    }
    .imgDes {
      width: 100%;
      margin-left: 0;
      text-align: center;
      padding: 0 0.3rem;
      box-sizing: border-box;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
